import Vue from 'vue'
import db from "@/firebaseConfig";

export default {
  namespaced: true,
  state: {
    basePrice: 0,
    depositAmount: 0,
    depositPercentage: 0,
    monthlyPayment: 0,
    period: 0,
    totalAmount: 0,
    multiplier: 1,
    pageStyle: undefined,
    pageStructure: undefined,
    additional: undefined,
    google: undefined,
    features: []
  },
  getters: {
    GET_BASE_PRICE: state => state.basePrice,
    GET_DEPOSIT_AMOUNT: state => state.depositAmount,
    GET_DEPOSIT_PERCENTAGE: state => state.depositPercentage,
    GET_MONTHLY_PAYMENT: state => state.monthlyPayment,
    GET_PERIOD: state => state.period,
    GET_TOTAL_AMOUNT: state => state.totalAmount,
    GET_MULTIPLIER: state => state.multiplier,
    GET_PAGE_STYLE: state => state.pageStyle,
    GET_PAGE_STRUCTURE: state => state.pageStructure,
    GET_ADDITIONAL: state => state.additional,
    GET_GOOGLE: state => state.google,
    GET_FEATURES: state => state.features
  },
  actions: {
    LOAD: context => {
      return new Promise((resolve, reject) => {
        const pricesRef = db.collection('prices').doc('vkgCOTjDBI3yTKXrNseS')
        pricesRef
            .get()
            .then(doc => {
              if (doc.exists) {
                const {base, pageStyle, pageStructure, additional, google, features} = doc.data()
                const {basePrice, depositAmount, depositPercentage, monthlyPayment, period, totalAmount} = base
                context.commit('SET_BASE_PRICE', basePrice)
                context.commit('SET_DEPOSIT_AMOUNT', depositAmount)
                context.commit('SET_DEPOSIT_PERCENTAGE', depositPercentage)
                context.commit('SET_MONTHLY_PAYMENT', monthlyPayment)
                context.commit('SET_PERIOD', period)
                context.commit('SET_TOTAL_AMOUNT', totalAmount)
                context.commit('SET_MULTIPLIER', pageStyle.basic.value)
                context.commit('SET_PAGE_STYLE', pageStyle)
                context.commit('SET_PAGE_STRUCTURE', pageStructure)
                context.commit('SET_ADDITIONAL', additional)
                context.commit('SET_GOOGLE', google)
                context.commit('SET_FEATURES', features)
                resolve()
              } else {
                // TODO: errorhandling
                reject()
              }
            })

      })
    },
    DEPOSIT_PERCENTAGE: (context, depositPercenage) => {
      context.commit('SET_DEPOSIT_PERCENTAGE', +depositPercenage)
      context.dispatch('RECALCULATE')
    },
    PERIOD: (context, period) => {
      context.commit('SET_PERIOD', +period)
      context.dispatch('RECALCULATE')
    },
    MULTIPLIER: (context, featureKey) => {
      const feature = context.getters['GET_PAGE_STYLE'][featureKey]
      const multiplier = feature.value
      const category = feature.category
      const features = context.getters['GET_FEATURES'].filter(el => el.category !== category)
      features.push({
        ...feature,
        value: 0
      })
      context.commit('SET_FEATURES', features)
      context.commit('SET_MULTIPLIER', +multiplier)
      context.dispatch('RECALCULATE')
    },
    STRUCTURE: (context, featureKey) => {
      const feature = context.getters['GET_PAGE_STRUCTURE'][featureKey]
      const features = context.getters['GET_FEATURES'].filter(el => el.category !== feature.category)
      features.push(feature)
      context.commit('SET_FEATURES', features)
      context.dispatch('RECALCULATE')
    },
    ADDITIONAL: (context, items) => {
      const features = context.getters['GET_FEATURES'].filter(el => el.category !== 'additional')
      const allAdditionals = context.getters['GET_ADDITIONAL']
      items.forEach(key => {
        features.push(allAdditionals[key])
      })
      context.commit('SET_FEATURES', features)
      context.dispatch('RECALCULATE')
    },
    GOOGLE: (context, items) => {
      const features = context.getters['GET_FEATURES'].filter(el => el.category !== 'google')
      const allAdditionals = context.getters['GET_GOOGLE']
      items.forEach(key => {
        features.push(allAdditionals[key])
      })
      context.commit('SET_FEATURES', features)
      context.dispatch('RECALCULATE')
    },
    RECALCULATE: context => {
      const basePrice = context.getters['GET_BASE_PRICE']
      const multiplier = context.getters['GET_MULTIPLIER']
      const depositPercentage = context.getters['GET_DEPOSIT_PERCENTAGE']
      const period = context.getters['GET_PERIOD']
      const features = context.getters['GET_FEATURES']
      const featuresAmount = +(features.reduce(function (accumulator, currentValue) {
        return accumulator + currentValue.value
      }, 0))
      const totalAmount = +((basePrice + featuresAmount) * multiplier)
      const depositAmount = +(totalAmount * (depositPercentage / 100))
      const monthlyPayment = +((totalAmount - depositAmount) / period)

      context.commit('SET_TOTAL_AMOUNT', totalAmount)
      context.commit('SET_DEPOSIT_AMOUNT', depositAmount)
      context.commit('SET_MONTHLY_PAYMENT', isFinite(monthlyPayment) ? monthlyPayment : 0)
    }
  },
  mutations: {
    SET_BASE_PRICE: (state, value) => Vue.set(state, 'basePrice', value),
    SET_DEPOSIT_AMOUNT: (state, value) => Vue.set(state, 'depositAmount', value),
    SET_DEPOSIT_PERCENTAGE: (state, value) => Vue.set(state, 'depositPercentage', value),
    SET_MONTHLY_PAYMENT: (state, value) => Vue.set(state, 'monthlyPayment', value),
    SET_PERIOD: (state, value) => Vue.set(state, 'period', value),
    SET_TOTAL_AMOUNT: (state, value) => Vue.set(state, 'totalAmount', value),
    SET_MULTIPLIER: (state, value) => Vue.set(state, 'multiplier', value),
    SET_PAGE_STYLE: (state, value) => Vue.set(state, 'pageStyle', value),
    SET_PAGE_STRUCTURE: (state, value) => Vue.set(state, 'pageStructure', value),
    SET_ADDITIONAL: (state, value) => Vue.set(state, 'additional', value),
    SET_GOOGLE: (state, value) => Vue.set(state, 'google', value),
    SET_FEATURES: (state, value) => Vue.set(state, 'features', value)
  }
}
